<template>
  <div v-show="value" class="preview_img_dialog" @click="handleAction('confirm')">
      <img class="img" :src="img" alt="" />

  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';

  export default create({
    name: 'PreviewImgDialog',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      img: {
        type: String,
        default: function () {
          return ''
        }
      }
    },
    methods: {
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      }
    }

  });
</script>


<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"
  .preview_img_dialog
    position: fixed;
    overflow: hidden;
    width 100%
    height 100%
    top 0
    left 0
    display flex
    align-items center
    justify-content center
    .img
      display block
      border-radius: .04rem;
      max-width 80%
      max-height 80%
</style>



// WEBPACK FOOTER //
// src/components/Popups/PreviewImgDialog/Dialog.vue